import {
  Component,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@/app/core/core.module';
import { ComparisonMode } from '@/app/core';

@Component({
  selector: 'rdo-nav-card-list',
  imports: [CoreModule, CommonModule],
  standalone: true,
  encapsulation: ViewEncapsulation.Emulated,
  styleUrl: './nav-card-list.component.scss',
  host: {
    class: 'rdo-col-card-fixed scroll categories-scroll-list',
    '(scroll)': 'onScroll.emit($event)',
  },
  template: `
    <div class="rdo-card-list">
      @for (c of list | slice: 0 : pageSize * currentPage; track c) {
        <rdo-nav-card
          [data]="c"
          [titleSelector]="titleProperty"
          [defaultTitle]="title"
          [comparisonMode]="mode"
          [selected]="checkSelected(c)"
          [rdo-scroll-into]="checkSelected(c)"
          (selectedChange)="onSelect.emit(c)"
        />
      }
    </div>
  `,
})
export class NavCardListComponent implements OnInit {
  @Input() title: string = 'main.tabs.equipment.all_title';
  @Input() list: any[] = [];
  @Input() pageSize: number = 10;
  @Input() currentPage: number = 1; // Usually pages start at 1 or handle 0-index logic
  @Input() mode: ComparisonMode = ComparisonMode.Benchmark;
  @Input() titleProperty: string = 'RouseCategory';

  // CHANGE 1: Pass the actual selected item, not a function
  @Input() selectedItem: any;

  // CHANGE 2: Use Outputs for events
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSelect = new EventEmitter<any>();
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onScroll = new EventEmitter<any>();

  ngOnInit() {
    // Debugging
  }

  // Helper to check selection internally
  checkSelected(c: any): boolean {
    if (!this.selectedItem) {
      return false;
    }
    // Adjust this comparison logic based on your data (e.g., compare IDs or References)
    return c[this.titleProperty] === this.selectedItem[this.titleProperty];
  }
}
